import { useEarlyAccess } from "./EarlyAccessContext";

export default function Footer() {
  const { open } = useEarlyAccess();
  return (
    <footer className="border-t border-[#e5e7eb] bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-2.5 sm:px-6 py-10">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="max-w-md">
            <div className="flex items-center gap-2.5">
              <img
                src="/logo.png"
                alt="LintelGrid Logo"
                className="h-9 w-9 object-contain"
              />
              <div className="flex flex-col justify-center leading-none">
                <span className="text-xl font-extrabold tracking-tight text-[#111827]">
                  Lintel<span className="text-[#1e3a8a]">Grid</span>
                </span>
                <span className="text-[11px] font-bold tracking-wider text-[#475569] uppercase mt-0.5">
                  Proptech
                </span>
              </div>
            </div>
            <p className="mt-4 text-[15px] font-medium text-[#334155]">
              Connect Better. Collaborate Smarter. Grow Together.
            </p>
            <p className="mt-2 text-sm text-[#94a3b8]">
              The network where real estate grows.
            </p>
          </div>

          <button
            onClick={() => open("general")}
            className="btn-primary rounded-full px-5 py-2 text-[13px] font-semibold text-white"
            data-testid="footer-join-button"
          >
            Join Early Access
          </button>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-[#eef1f6] pt-6 text-sm text-[#94a3b8] sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} LintelGrid. All rights reserved.</p>
          <p className="font-medium text-[#64748b]">
            A Venture by{" "}
            <span className="text-[#1e3a8a]">MindsAhead Venture Studio</span>.
          </p>
        </div>
      </div>
    </footer>
  );
}
